<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ (state === 'desired' ? 'select_rank_desired' : 'select_rank') | translate: lang }}</h5>
  <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">

  <div class="row">

    <div class="col-md text-center" *ngIf="min < 5 && max >= 1">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/4.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(1)" *ngIf="min < 2 && max >= 1">Rookie IV</div>
      <div class="rank-select-item" (click)="onSelect(2)" *ngIf="min < 3 && max >= 2">Rookie III</div>
      <div class="rank-select-item" (click)="onSelect(3)" *ngIf="min < 4 && max >= 3">Rookie II</div>
      <div class="rank-select-item" (click)="onSelect(4)" *ngIf="min < 5 && max >= 4">Rookie I</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 9 && max >= 5">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/8.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(5)" *ngIf="min < 6 && max >= 5">Bronze IV</div>
      <div class="rank-select-item" (click)="onSelect(6)" *ngIf="min < 6 && max >= 5">Bronze III</div>
      <div class="rank-select-item" (click)="onSelect(7)" *ngIf="min < 8 && max >= 7">Bronze II</div>
      <div class="rank-select-item" (click)="onSelect(8)" *ngIf="min < 9 && max >= 8">Bronze I</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 13 && max >= 9">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/12.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(9)" *ngIf="min < 10 && max >= 9">Silver IV</div>
      <div class="rank-select-item" (click)="onSelect(10)" *ngIf="min < 11 && max >= 10">Silver III</div>
      <div class="rank-select-item" (click)="onSelect(11)" *ngIf="min < 12 && max >= 11">Silver II</div>
      <div class="rank-select-item" (click)="onSelect(12)" *ngIf="min < 13 && max >= 12">Silver I</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 17 && max >= 13">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/16.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(13)" *ngIf="min < 14 && max >= 13">Gold IV</div>
      <div class="rank-select-item" (click)="onSelect(14)" *ngIf="min < 15 && max >= 14">Gold III</div>
      <div class="rank-select-item" (click)="onSelect(15)" *ngIf="min < 16 && max >= 15">Gold II</div>
      <div class="rank-select-item" (click)="onSelect(16)" *ngIf="min < 17 && max >= 16">Gold I</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 21 && max >= 17">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/20.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(17)" *ngIf="min < 18 && max >= 17">Platinum IV</div>
      <div class="rank-select-item" (click)="onSelect(18)" *ngIf="min < 19 && max >= 18">Platinum III</div>
      <div class="rank-select-item" (click)="onSelect(19)" *ngIf="min < 20 && max >= 19">Platinum II</div>
      <div class="rank-select-item" (click)="onSelect(20)" *ngIf="min < 21 && max >= 20">Platinum I</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 25 && max >= 21">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/24.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(21)" *ngIf="min < 22 && max >= 21">Diamond IV</div>
      <div class="rank-select-item" (click)="onSelect(22)" *ngIf="min < 23 && max >= 22">Diamond III</div>
      <div class="rank-select-item" (click)="onSelect(23)" *ngIf="min < 24 && max >= 23">Diamond II</div>
      <div class="rank-select-item" (click)="onSelect(24)" *ngIf="min < 25 && max >= 24">Diamond I</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 26 && max >= 25">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/25.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(25)" *ngIf="min < 26 && max >= 25">Master</div>
    </div>
    <div class="col-md text-center" *ngIf="min < 27 && max >= 26">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/26.webp' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(26)" *ngIf="min < 27 && max >= 26">Predator</div>
    </div>
  </div>

</div>
